import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "tr" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "统一社会信用代码", -1)
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "企业名称", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "曾用名", -1)
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "tr" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "法定代表人", -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "登记状态", -1)
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "成立时间", -1)
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "tr" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "投资人", -1)
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { href: "/business/investor" }
const _hoisted_27 = { class: "item" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "注册资本", -1)
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "item" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "实缴资本", -1)
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "tr" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "英文名", -1)
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "item" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "变更记录", -1)
const _hoisted_39 = {
  key: 0,
  class: "value"
}
const _hoisted_40 = { href: "/change" }
const _hoisted_41 = {
  key: 1,
  class: "value"
}
const _hoisted_42 = { class: "item" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "更新时间", -1)
const _hoisted_44 = { class: "value" }
const _hoisted_45 = { class: "tr" }
const _hoisted_46 = { class: "item" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "是否上市", -1)
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "item" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "上市类型", -1)
const _hoisted_51 = { class: "value" }
const _hoisted_52 = { class: "item" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "股票代码", -1)
const _hoisted_54 = { class: "value" }
const _hoisted_55 = { class: "tr" }
const _hoisted_56 = { class: "item" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "组织机构代码", -1)
const _hoisted_58 = { class: "value" }
const _hoisted_59 = { class: "item" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "工商注册码", -1)
const _hoisted_61 = { class: "value" }
const _hoisted_62 = { class: "item" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "进出口企业代码", -1)
const _hoisted_64 = { class: "value" }
const _hoisted_65 = { class: "tr" }
const _hoisted_66 = {
  class: "item",
  style: {"flex":"2"}
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "企业类型", -1)
const _hoisted_68 = { class: "value" }
const _hoisted_69 = { class: "item" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "分支机构", -1)
const _hoisted_71 = {
  key: 0,
  class: "value"
}
const _hoisted_72 = { href: "/business/branch" }
const _hoisted_73 = {
  key: 1,
  class: "value"
}
const _hoisted_74 = { class: "tr" }
const _hoisted_75 = { class: "item" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "注销吊销信息", -1)
const _hoisted_77 = { class: "value" }
const _hoisted_78 = { class: "item" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "营业期限", -1)
const _hoisted_80 = { class: "value" }
const _hoisted_81 = { class: "item" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "发照时间", -1)
const _hoisted_83 = { class: "value" }
const _hoisted_84 = { class: "tr" }
const _hoisted_85 = { class: "item" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "所属行业", -1)
const _hoisted_87 = { class: "value" }
const _hoisted_88 = { class: "item" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "所属地区", -1)
const _hoisted_90 = { class: "value" }
const _hoisted_91 = { class: "item" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "登记机关", -1)
const _hoisted_93 = { class: "value" }
const _hoisted_94 = { class: "tr" }
const _hoisted_95 = { class: "item" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "主要人员", -1)
const _hoisted_97 = { class: "value" }
const _hoisted_98 = { href: "/business/personnel" }
const _hoisted_99 = { class: "item" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "人员规模", -1)
const _hoisted_101 = { class: "value" }
const _hoisted_102 = { class: "item" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "参保人数", -1)
const _hoisted_104 = { class: "value" }
const _hoisted_105 = { class: "tr" }
const _hoisted_106 = { class: "item" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "网址", -1)
const _hoisted_108 = { class: "value" }
const _hoisted_109 = { class: "item" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "联系电话", -1)
const _hoisted_111 = { class: "value" }
const _hoisted_112 = { class: "item" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "邮箱", -1)
const _hoisted_114 = { class: "value" }
const _hoisted_115 = { class: "tr" }
const _hoisted_116 = { class: "item" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "注册地址", -1)
const _hoisted_118 = { class: "value" }
const _hoisted_119 = { class: "tr" }
const _hoisted_120 = { class: "item" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "经营范围", -1)
const _hoisted_122 = {
  class: "value",
  style: {"padding":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.d.creditCode), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.d.name), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.d.originalName.length>0?_ctx.d.originalName[0].name:'无'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.d.operName), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.d.status), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.toDate(_ctx.d.startDate,'YYYY-MM-DD')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("a", _hoisted_26, _toDisplayString(_ctx.d.partners.length) + "人", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.d.registCapi), 1)
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.d.recCap || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.d.englishName), 1)
      ]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        (_ctx.d.changeRecords.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("a", _hoisted_40, _toDisplayString(_ctx.d.changeRecords.length), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_41, "-"))
      ]),
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.toDate(_ctx.d.updatedDate,'YYYY-MM-DD')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.d.isOnStock == '1'?'是':'否'), 1)
      ]),
      _createElementVNode("div", _hoisted_49, [
        _hoisted_50,
        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.d.stockType || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_52, [
        _hoisted_53,
        _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.d.stockNumber || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.d.orgNo || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.d.no || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_62, [
        _hoisted_63,
        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.d.ixcode || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _hoisted_67,
        _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.d.econKind || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_69, [
        _hoisted_70,
        (_ctx.d.branches.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
              _createElementVNode("a", _hoisted_72, _toDisplayString(_ctx.d.branches.length) + "家", 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_73, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_74, [
      _createElementVNode("div", _hoisted_75, [
        _hoisted_76,
        _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.d.revokeInfo ? _ctx.d.revokeInfo.cancelReason:'-'), 1)
      ]),
      _createElementVNode("div", _hoisted_78, [
        _hoisted_79,
        _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.toDate(_ctx.d.termStart,'YYYY-MM-DD')) + " - " + _toDisplayString(_ctx.d.teamEnd===''?'':_ctx.toDate(_ctx.d.teamEnd,'YYYY-MM-DD')), 1)
      ]),
      _createElementVNode("div", _hoisted_81, [
        _hoisted_82,
        _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.toDate(_ctx.d.termStart,'YYYY-MM-DD')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_84, [
      _createElementVNode("div", _hoisted_85, [
        _hoisted_86,
        _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.d.industry.subIndustry || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_88, [
        _hoisted_89,
        _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.d.area.province || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_91, [
        _hoisted_92,
        _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.d.belongOrg || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_94, [
      _createElementVNode("div", _hoisted_95, [
        _hoisted_96,
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("a", _hoisted_98, _toDisplayString(_ctx.d.employees.length) + "人", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_99, [
        _hoisted_100,
        _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.d.personScope || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_102, [
        _hoisted_103,
        _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.d.insuredCount || '0') + "人", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_105, [
      _createElementVNode("div", _hoisted_106, [
        _hoisted_107,
        _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.d.contactInfo.webSite && _ctx.d.contactInfo.webSite.length>0?_ctx.d.contactInfo.webSite[0].url:'-'), 1)
      ]),
      _createElementVNode("div", _hoisted_109, [
        _hoisted_110,
        _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.d.contactInfo.phoneNumber || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_112, [
        _hoisted_113,
        _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.d.contactInfo.email || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_115, [
      _createElementVNode("div", _hoisted_116, [
        _hoisted_117,
        _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.d.address || '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_119, [
      _createElementVNode("div", _hoisted_120, [
        _hoisted_121,
        _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.d.scope || '-'), 1)
      ])
    ])
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
}